export const enum BetStatus {
  Active = 'active',
  Suspended = 'suspended',
  EarlySuspended = 'early suspended',
}
